import React from 'react';
import { motion } from 'framer-motion';
import { Map, Target, Rocket } from 'lucide-react';
export function Slide12NextSteps() {
  const steps = [{
    num: '01',
    title: 'Map the journey',
    desc: 'Identify the congress stages and likely engagement bottlenecks.',
    icon: Map
  }, {
    num: '02',
    title: 'Choose the use case',
    desc: 'Select one pilot that is valuable, practical and easy to approve internally.',
    icon: Target
  }, {
    num: '03',
    title: 'Launch, learn and expand',
    desc: 'Deploy the Snak, collect data and recommend the next step based on results.',
    icon: Rocket
  }];
  return <div className="h-full w-full bg-[#1A1A2E] text-white flex flex-col p-12 md:px-24 md:pt-16 md:pb-24 relative overflow-hidden" data-id="element-65">
      {/* Background accents */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-[#E60012]/10 to-transparent pointer-events-none" data-id="element-66" />
      <div className="absolute -bottom-[20%] -left-[10%] w-[50%] h-[50%] rounded-full bg-[#E60012]/20 blur-[100px] pointer-events-none" data-id="element-67" />

      <header className="mb-10" data-id="element-68">
        <motion.h2 className="text-4xl md:text-5xl font-bold mb-4" initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-69">
          Suggested next step:{' '}
          <span className="text-[#FF6B6B]" data-id="element-70">map, choose, pilot.</span>
        </motion.h2>
        <motion.p className="text-xl text-gray-300 font-light max-w-3xl" initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} data-id="element-71">
          Once Takeda shares the campaign briefing materials, Snakker can
          recommend the strongest first use case.
        </motion.p>
      </header>

      <main className="flex-1 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl w-full" data-id="element-72">
        {steps.map((step, index) => {
        const Icon = step.icon;
        return <motion.div key={step.num} className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10 relative overflow-hidden group hover:bg-white/10 transition-colors" initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.3 + index * 0.15
        }} data-id="element-73">
              <div className="absolute -top-4 -right-4 text-8xl font-bold text-white/5 group-hover:text-white/10 transition-colors pointer-events-none" data-id="element-74">
                {step.num}
              </div>

              <div className="w-14 h-14 rounded-xl bg-[#E60012]/20 flex items-center justify-center mb-6 relative z-10" data-id="element-75">
                <Icon className="w-7 h-7 text-[#FF6B6B]" data-id="element-76" />
              </div>

              <h3 className="text-2xl font-bold mb-4 relative z-10" data-id="element-77">
                {step.title}
              </h3>
              <p className="text-gray-400 leading-relaxed relative z-10" data-id="element-78">
                {step.desc}
              </p>
            </motion.div>;
      })}
      </main>

      <motion.footer className="mt-10 pt-6 border-t border-white/10 flex flex-col items-center text-center" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.8,
      delay: 1
    }} data-id="element-79">
        <p className="text-gray-300 mb-2" data-id="element-80">
          Snakker helps Takeda turn congress activity into a measurable
          engagement journey, one focused use case at a time.
        </p>
        <p className="text-2xl font-bold text-white" data-id="element-81">
          Map the full congress journey.{' '}
          <span className="text-[#FF6B6B]" data-id="element-82">Start with one bottleneck.</span>
        </p>
      </motion.footer>
    </div>;
}